// Forget every public read core keeps for the session (registration step 33).
// Called by SiteAccessProvider when a private site's visitor is admitted, stops
// being admitted, or changes credential: data read under one credential (or a
// refusal recorded as "no data") must not be served under another.

import { resetSharedRequests } from '../data/shared'
import { resetSiteTeamsCache } from '../data/useSiteTeams'
import { resetScoreboardStripCache } from '../data/useScoreboardStrip'
import { resetEntitySportLookups } from '../template/entitySport'

export function resetPublicCaches(): void {
  resetSharedRequests()
  resetSiteTeamsCache()
  resetScoreboardStripCache()
  resetEntitySportLookups()
}
